<template>
  <div class="routing-dropzone">

    <draggable class="dropzone-items" v-show="items.length > 0" v-model="items">
      <div class="dropzone-item" v-for="(item, index) in items">

        <div class="header">
          <span v-bind:class="{ order: true, dropoff: !item.isPickup }">{{ index + 1}}</span>
          <a :href="'/#/reservation/' + item.reservationID"
             target="_blank">{{ item.reservationID }}</a>
          <span v-if="item.packageID !== null">-</span>
          <a :href="'/#/package/' + item.packageID" v-if="item.packageID !== null"
             target="_blank">{{ item.packageID }}</a>
          <span class="icon-label">
            <i class="fas fa-suitcase"></i>
            <span>{{ item.luggage }}</span>
          </span>
          <span class="icon-label">
            <i class="fas fa-user"></i>
            <span>{{ item.passengers }}</span>
          </span>
          <span class="icon-label location">
            <i v-bind:class="{ 'fas fa-map-marker-alt fa-fw': true, dropoff: !item.isPickup }"></i>
            <span>{{ getAddress(item.location) }}</span>
          </span>
        </div>

        <div class="body">
          <span class="icon-label time" v-if="item.isPickup">
            <i class="fas fa-clock"></i>
            <span class="label">PUT:</span>
            <span class="value">{{ item.originalPickupTime }}</span>
          </span>
          <span class="icon-label time" v-if="index > 0 && !item.isPickup">
            <i class="fas fa-clock"></i>
            <span class="label">BTT:</span>
            <span class="value">{{ computeOriginalBTT(item) }}</span>
          </span>
          <span class="icon-label time" v-if="index > 0">
            <i class="fas fa-clock"></i>
            <span class="label">ETA:</span>
            <span class="value">{{ computeEta(item) }}</span>
          </span>
          <span v-bind:class="{ 'icon-label validation': true, warning: showWarning(item) }" v-if="index > 0">
            <i class="fas fa-exclamation-triangle fa-fw warning"></i>
            <i class="fas fa-check-circle fa-fw success"></i>
            <span>{{ hasIssues(item) }}</span>
          </span>
        </div>

        <a class="remove-item" href="javascript:;" v-if="item.isPickup && item.status !== 'COMPLETED' && item.status !== 'CANCELED'"
          @click="removeFromMap(item)">
          <i class="fas fa-minus-square"></i>
        </a>
      </div>
    </draggable>

    <dropzone-controls></dropzone-controls>

    <div v-bind:class="{ 'check-route-loading': true, show: checkRouteLoading }">
      <loader-map-marker></loader-map-marker>
      <div class="title">
        <div class="text">Finding optimal route...</div>
      </div>
    </div>

    <div class="empty-container" v-show="items.length <= 0">
      <div class="empty">
        <div class="empty-content">
          <img src="/assets/img/routing-empty.png" />
          <div class="title">Nothing here yet!</div>
          <div class="message">Drop a shared reservation/package here or click on the map marker icons to begin routing.</div>
        </div>
      </div>
    </div>

    <drop v-bind:class="{ dropzone: true, show: showDropzone, 'empty-container': true }" @drop="handleDrop">
      <div class="empty">
        <div class="empty-content">
          <i class="fas fa-arrow-alt-circle-down fa-4x"></i>
          <div class="title">Drop it here!</div>
        </div>
      </div>
    </drop>
  </div>
</template>

<script>
import moment from 'moment'
import Draggable from 'vuedraggable'
import DropzoneControls from './DropzoneControls'
import LoaderMapMarker from '@/components/Partials/LoadingAnimation/MapMarker'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'dropzone',
  components: { Draggable, DropzoneControls, LoaderMapMarker },
  data () {
    return {
      overDropZone: false
    }
  },
  computed: {
    items: {
      get () { return this.$store.state.laxit.dropzone.items.filter(x => x.mapOnly === false) },
      set (value) {
        // a rsvp dropoff should not occur before pickup
        let stops = value
        for (let i = 0; i < stops.length; i++) {
          let rsvpID = stops[i].reservationID
          let rsvps = stops.filter(stop => stop.reservationID === rsvpID)
          if (rsvps.length < 2) {
            return
          }
          if (!rsvps[0].isPickup) {
            return
          }
        }
        this.$store.commit('laxit/setDropzoneItems', value)
      }
    },
    showDropzone () { return this.$store.state.laxit.dropzone.show },
    checkRouteLoading () { return this.$store.state.laxit.dropzone.checkRoute }
  },
  methods: {
    handleDrop (data) {
      let self = this
      let items = self.items
      console.log(data)
      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        if (data.type === 'package') {
          if (item.packageID === data.id) {
            return
          }
        }
        else {
          if (item.reservationID === data.id) {
            return
          }
        }
      }
      self.removeMapOnlyItems()
      self.$store.commit('laxit/addDropzoneItem', data)
      if (data.type === 'package' && data.driver && data.driver !== null) {
        self.$store.commit('laxit/addDropzoneDriver', {
          packageID: data.id,
          driver: data.driver
        })
      }
    },
    computeEta (stop) {
      let self = this
      let firstStop = self.items[0]
      return moment(firstStop.pickupTime, 'MM/DD/YYYY hh:mmA').add(stop.eta, 'seconds').format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
    },
    computeMaxEta (stop) {
      return moment(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(stop.maxDuration, 'seconds').format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
    },
    computeOriginalBTT (stop) {
      return moment(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(stop.originalBTT, 'seconds').format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
    },
    showWarning (stop) {
      let self = this
      let firstStop = self.items[0]
      let eta = moment(firstStop.pickupTime, 'MM/DD/YYYY hh:mmA').add(stop.eta, 'seconds')
      let target = moment(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(stop.originalBTT, 'seconds')
      if (stop.isPickup) {
        target = moment(stop.pickupTime, 'MM/DD/YYYY hh:mmA')
      }
      return eta.isAfter(target)
    },
    hasIssues (stop) {
      let self = this
      let firstStop = self.items[0]
      let eta = moment(firstStop.pickupTime, 'MM/DD/YYYY hh:mmA').add(stop.eta, 'seconds')
      let target = moment(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(stop.originalBTT, 'seconds')
      if (stop.isPickup) {
        target = moment(stop.originalPickupTime, 'MM/DD/YYYY hh:mmA')
      }
      if (eta.isAfter(target)) {
        return 'Will arrive ' + moment.duration(target.diff(eta)).humanize() + ' after the ' +
          (stop.isPickup ? 'Orginal Pickup Time.' : 'Be There Time.')
      }
      return 'Will arrive ' + moment.duration(target.diff(eta)).humanize() + ' before the ' +
        (stop.isPickup ? 'Original Pickup Time.' : 'Be There Time.')
    },
    getAddress (location) {
      if (location.geofenceType === 'airport' &&
          location.geofenceName !== '') {
        let result = location.geofenceName
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal
        }
        return result
      }
      return location.title

      // let address = ''
      // if (location.address2 && location.address2 !== '' && location.address2 !== 'undefined') {
      //   address = address + location.address2 + ' '
      // }
      // if (location.address1) {
      //   address = address + location.address1 + ', '
      // }
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.state) {
      //   address = address + location.state + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      // return address
    },
    removeFromMap (item) {
      let self = this
      self.$store.commit('laxit/removeDropzoneItem', item)

      // remove dropzone driver
      self.removeDriver(item.packageID)
    },
    removeDriver (packageID) {
      if (packageID === null) {
        return
      }

      let self = this
      let stops = self.$store.state.laxit.dropzone.items
      if (stops.filter(stop => stop.packageID === packageID).length > 0) {
        return
      }

      let drivers = self.$store.state.laxit.dropzone.drivers
      let remainingDrivers = drivers.filter(item => item.packageID !== packageID)
      self.$store.commit('laxit/setDropzoneDrivers', remainingDrivers)
    },
    removeMapOnlyItems () {
      if (this.$store.state.laxit.tncReservations.viewingInMap) {
        this.$store.commit('laxit/clearDropzone')
        this.$store.commit('laxit/setViewingInMap', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.routing-dropzone{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.empty-container {
  display: table;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0);
  transition: all 500ms;

  &.dragover {
    background-color: rgba(0,0,0,0.6);
  }

  & .empty {
    display: table-cell;
    vertical-align: middle;
  }

  & .empty-content {
    max-width: 350px;
    padding: 0 15px;
    margin: 0 auto;
    text-align: center;
    font-weight: 700;

    & img {
      display: block;
      width: 200px;
      margin: 0 auto;
    }

    & .title {
      font-size: 22px;
      color: #3F2975;
      margin-top: 15px;
    }
    & .message {
      margin-top: 5px;
      font-size: 16px;
      color: #555;
    }
  }
}


.dropzone {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.75);
  transition: all 250ms;

  &.show { top: 0; }

  & .empty-content i { color: #fff; }
  & .empty-content .title{ color: #fff; }
}

.dropzone-items {
  padding: 10px 10px 5px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 70px);
  overflow: auto;
}
.dropzone-item {
  position: relative;
  background-color: #fff;
  margin-bottom: 5px;
  border: 1px solid rgba(0,0,0,0.3);
  border-radius: 3px;

  & .remove-item {
    position: absolute;
    top: 17px;
    right: 10px;
    text-decoration: none;
    color: #F20D0D;
  }

  & a { font-weight: 700; }

  & .header {
    font-size: 12px;
    padding: 5px;
  }

  & .order {
    display: inline-block;
    margin-right: 5px;
    background-color: #26D97A;
    color: #fff;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-weight: 700;
    border-radius: 100%;
    &.dropoff { background-color: #F20D0D; }
  }

  & .icon-label {
    display: inline-block;
    margin-left: 10px;
    color: #555;

    &.location {
      margin: 0;
      padding: 0 25px 0 5px;
      color: #555;
      font-weight: 700;
      display: block;
      margin: 5px 0;

      & i{ color: #26D97A; }
      & i.dropoff{ color: #F20D0D; }
    }

    &.time {
      & .value { font-weight: 700; }
    }

    &.validation {
      color: #229e5c;
      & i.success { display: inline-block; }
      & i.warning { display: none; }
      &.warning {
        color: #F25E0D;
        & i.success { display: none; }
        & i.warning{ display: inline-block; }
      }
    }
  }

  & .body {
    font-size: 12px;
    padding: 0 15px 10px 0;
    text-align: left;
  }
}

.check-route-loading {
  display: table;
  position: absolute;
  bottom: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,0.9);
  transition: all 250ms;
  &.show{ bottom: 0; }

  & .title {
    display: table-cell;
    vertical-align: middle;
    width: 100%;
    height: 100%;
    text-align: center;
    color: #555;
    font-weight: 700;
    font-size: 18px;

    & .text {
      display: inline-block;
      margin-top: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Laxit/Dropzone.vue